"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitInfo = void 0;
const immer_1 = __importDefault(require("immer"));
const action_constants_1 = require("../../../shared/store/action_constants");
const defaultState = {
    unitMap: null,
    userMap: null,
};
const updateUnitMap = (oldUnitMap, newUnitMap) => {
    return Object.assign(Object.assign({}, (oldUnitMap || {})), newUnitMap);
};
const updateUserMap = (oldUserMap, newUserMap) => {
    if (!oldUserMap) {
        oldUserMap = {};
    }
    const _unitMap = {};
    for (const k in newUserMap) {
        const value = newUserMap[k];
        if (value.unitId) {
            oldUserMap[k] = value.unitId;
            _unitMap[value.unitId] = value;
            continue;
        }
        oldUserMap[k] = value;
    }
    return { oldUserMap, _unitMap };
};
exports.unitInfo = (0, immer_1.default)((state = defaultState, action) => {
    switch (action.type) {
        case action_constants_1.UPDATE_UNIT_MAP: {
            state.unitMap = updateUnitMap(state.unitMap, action.payload);
            break;
        }
        case action_constants_1.UPDATE_USER_MAP: {
            const { oldUserMap: userMap, _unitMap } = updateUserMap(state.userMap, action.payload);
            const unitMap = updateUnitMap(state.unitMap, _unitMap);
            state.userMap = userMap;
            state.unitMap = unitMap;
            break;
        }
        case action_constants_1.RESET_UNIT_INFO: {
            return defaultState;
        }
    }
    return state;
});
//# sourceMappingURL=unit_info.js.map